import $ from 'jquery';

export default function () {
    if ($(window).height() < $(document).height()) {
        $('.go-to-top').addClass('visible');
    }

    $(document).on('click', '.go-to-top__inner', function () {
        document.querySelector('.navbar').scrollIntoView({
            behavior: 'smooth'
        });
    });
};


// WEBPACK FOOTER //
// ./App/components/modules/goToTopButton.js